const PREFIX = 'crowdpear__';

export const TIMER_STORAGE = `${PREFIX}timer_storage`;

export const ACCESS_TOKEN = 'access_token';
export const REFRESH_TOKEN = 'refresh_token';

export const IS_SOLD_INVESTMENT = `${PREFIX}_sold_investment`;

export const TARGET_URL = 'target_url';

export const USER_NOTICE = 'user_notice';
